import { render } from "./EmptyLayout.vue?vue&type=template&id=43f6a8f9"
import script from "./EmptyLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/core/layout/EmptyLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43f6a8f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43f6a8f9', __exports__)) {
    console.log('reload')
    api.reload('43f6a8f9', __exports__)
  }
  
  module.hot.accept("./EmptyLayout.vue?vue&type=template&id=43f6a8f9", () => {
    console.log('re-render')
    api.rerender('43f6a8f9', render)
  })

}


export default __exports__